import './App.css';
import List from './components/List/List';

function App() {
  return (
    <div className="App">
      <div className="wrapper">
        <List/>
      </div>
    </div>
  );
}

export default App;
